var _path, _path2, _g, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_13",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9_13",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9_13)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.5C7.99187 1.5 1.5 7.99187 1.5 16C1.5 24.0081 7.99187 30.5 16 30.5C24.0081 30.5 30.5 24.0081 30.5 16C30.5 7.99187 24.0081 1.5 16 1.5ZM0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#ADB5BD"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3963 17.0187H17.6038C17.8164 17.0187 18.0204 16.9342 18.1708 16.7838C18.3212 16.6334 18.4056 16.4295 18.4056 16.2168C18.4056 16.0041 18.3212 15.8002 18.1708 15.6498C18.0204 15.4994 17.8164 15.4149 17.6038 15.4149H14.3963C14.1836 15.4149 13.9796 15.4994 13.8293 15.6498C13.6789 15.8002 13.5944 16.0041 13.5944 16.2168C13.5944 16.4295 13.6789 16.6334 13.8293 16.7838C13.9796 16.9342 14.1836 17.0187 14.3963 17.0187ZM21.6131 9H10.3869C9.8228 9.00438 9.27813 9.20689 8.84817 9.57215C8.4182 9.9374 8.13028 10.4421 8.03475 10.9982C7.93921 11.5542 8.04214 12.1261 8.32553 12.6139C8.60892 13.1017 9.05475 13.4744 9.58508 13.6669V21.028C9.58508 21.666 9.83852 22.2779 10.2897 22.729C10.7408 23.1801 11.3527 23.4336 11.9907 23.4336H20.0094C20.6474 23.4336 21.2593 23.1801 21.7104 22.729C22.1615 22.2779 22.415 21.666 22.415 21.028V13.6669C22.9453 13.4744 23.3911 13.1017 23.6745 12.6139C23.9579 12.1261 24.0608 11.5542 23.9653 10.9982C23.8698 10.4421 23.5818 9.9374 23.1519 9.57215C22.7219 9.20689 22.1773 9.00438 21.6131 9ZM20.8112 21.028C20.8112 21.2407 20.7268 21.4446 20.5764 21.595C20.426 21.7454 20.222 21.8299 20.0094 21.8299H11.9907C11.778 21.8299 11.574 21.7454 11.4237 21.595C11.2733 21.4446 11.1888 21.2407 11.1888 21.028V13.8112H20.8112V21.028ZM21.6131 12.2075H10.3869C10.1743 12.2075 9.97032 12.123 9.81994 11.9726C9.66956 11.8222 9.58508 11.6183 9.58508 11.4056C9.58508 11.1929 9.66956 10.989 9.81994 10.8386C9.97032 10.6882 10.1743 10.6037 10.3869 10.6037H21.6131C21.8258 10.6037 22.0297 10.6882 22.1801 10.8386C22.3305 10.989 22.415 11.1929 22.415 11.4056C22.415 11.6183 22.3305 11.8222 22.1801 11.9726C22.0297 12.123 21.8258 12.2075 21.6131 12.2075Z",
    fill: "#ADB5BD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveRound);
export default __webpack_public_path__ + "static/media/archive-round.0311874dccb32b70a234f740cc9998aa.svg";
export { ForwardRef as ReactComponent };